import { createSelector } from '@reduxjs/toolkit';
import { PAY_BTN_STATUSES } from "../../../constants/payment";
export var getSberState = function getSberState(state) {
  return state.sberpay;
};
export var getSberPayFlag = function getSberPayFlag(state) {
  return getSberState(state).fetched;
};
export var getSberPayFrom3DS = function getSberPayFrom3DS(state) {
  return getSberState(state).from3DS;
};
export var getSberPayContent = function getSberPayContent(state) {
  return getSberState(state).content;
};
export var getSberPayErrorText = function getSberPayErrorText(state) {
  var _getSberPayContent;
  return ((_getSberPayContent = getSberPayContent(state)) === null || _getSberPayContent === void 0 || (_getSberPayContent = _getSberPayContent.error) === null || _getSberPayContent === void 0 ? void 0 : _getSberPayContent.title) || '';
};
export var getSberPayUnBinded = function getSberPayUnBinded(state) {
  return getSberState(state).unBinded;
};
export var getSberPayBinding = function getSberPayBinding(state) {
  return getSberState(state).binding || {};
};
export var getSberPayId = function getSberPayId(state) {
  return getSberState(state).payId;
};
export var getSberPaymentStatus = function getSberPaymentStatus(state) {
  var _getSberState$payment, _getSberState;
  return (_getSberState$payment = (_getSberState = getSberState(state)) === null || _getSberState === void 0 ? void 0 : _getSberState.paymentStatus) !== null && _getSberState$payment !== void 0 ? _getSberState$payment : PAY_BTN_STATUSES.initial;
};
export var getSberPendingBinding = function getSberPendingBinding(state) {
  var _getSberState2;
  return (_getSberState2 = getSberState(state)) === null || _getSberState2 === void 0 ? void 0 : _getSberState2.pendingBinding;
};
export var getSberSdkEnabled = function getSberSdkEnabled(state) {
  var _getSberState3;
  return (_getSberState3 = getSberState(state)) === null || _getSberState3 === void 0 ? void 0 : _getSberState3.sberSdkEnabled;
};
export var getSberPaySettings = function getSberPaySettings(state) {
  var store = getSberState(state);
  return {
    enabled: store.enabled,
    mobileEnabled: store.mobileEnabled,
    isAuthenticated: store.isAuthenticated
  };
};
export var getSberIsAuthenticated = createSelector(getSberPaySettings, function (_ref) {
  var isAuthenticated = _ref.isAuthenticated;
  return isAuthenticated;
});
export var getNotShouldRenderSberWidget = createSelector(getSberPayContent, getSberPaySettings, function (content, settings) {
  return !content || settings.enabled === false;
});
export var getShowSberResultPopup = createSelector(getSberPayFlag, getSberPayFrom3DS, getSberPaymentStatus, function (fetched, sberPay3DS, paymentStatus) {
  return fetched && [PAY_BTN_STATUSES.success, PAY_BTN_STATUSES.error].includes(paymentStatus) || sberPay3DS;
});
export var getShowPaymentProcess = createSelector(getSberPayUnBinded, getShowSberResultPopup, getSberPayId, function (unBinded, hasResult, payId) {
  return unBinded && !hasResult && !payId;
});
export var getTurnedOnSberScenario = createSelector(getSberPayUnBinded, getShowSberResultPopup, getSberPayId, function (unBinded, hasResult, payId) {
  return (unBinded || hasResult) && !payId;
});